import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SystemCapabilityEnum } from 'src/app/models/data/systemCapability';
import { User } from 'src/app/models/data/user';
import { ApiService } from 'src/app/services/api.services';
import { SystemCapabilityService } from 'src/app/services/system-capabilities/system-capability.service';
import { AppTabNavigationHeaderComponent } from '../../../components/navigation-header/app-navigation-header.component';
import { MatTabGroup, MatTab, MatTabContent } from '@angular/material/tabs';
import { QueryStringTabGroupDirective } from '../../../directives/query-string-tab-group.directive';
import { UserAboutComponent } from './user-about/user-about.component';
import { BreadcrumbLabelDirective } from '../../../directives/breadcrumb-label.directive';
import { UserEventHistoryComponent } from './user-event-history/user-event-history.component';
import { AuditLogListComponent } from '../../audit-log-list/audit-log-list.component';

@Component({
	selector: 'app-user-detail',
	templateUrl: './user-detail.component.html',
	styleUrls: ['./user-detail.component.scss', '../../common/main.scss'],
	imports: [
		AppTabNavigationHeaderComponent,
		MatTabGroup,
		QueryStringTabGroupDirective,
		MatTab,
		MatTabContent,
		UserAboutComponent,
		BreadcrumbLabelDirective,
		UserEventHistoryComponent,
		AuditLogListComponent,
	],
})
export class UserDetailComponent implements OnInit {
	userId = this.route.snapshot.params.id;
	companyId: string | undefined = this.route.snapshot.params.companyId;
	user?: User;

	canAccessEventHistory: boolean = false;
	canAccessAuditLogs: boolean = false;

	aboutBreadcrumbLabel = '';
	accessHistoryBreadcrumbLabel = '';
	auditLogBreadcrumbLabel = '';

	get userName(): string {
		const fullName =
			(this.user?.firstName ?? '') + ' ' + (this.user?.lastName ?? '');
		return fullName.trim();
	}

	constructor(
		private route: ActivatedRoute,
		private api: ApiService,
		private readonly systemCapabilityService: SystemCapabilityService
	) {}

	updateBreadcrumbLabels(): void {
		this.aboutBreadcrumbLabel = `${this.user?.firstName} ${this.user?.lastName}`;
		this.accessHistoryBreadcrumbLabel = `${this.user?.firstName} ${this.user?.lastName}`;
		this.auditLogBreadcrumbLabel = `${this.user?.firstName} ${this.user?.lastName}`;
	}

	async ngOnInit(): Promise<void> {
		// I moved these setting these variables into the ngOnInit method because they seem to depend on information from the router (the companyId)
		// and that isn't always available at the time the constructor runs
		this.canAccessEventHistory =
			this.systemCapabilityService.has(
				SystemCapabilityEnum.userRoleManagement
			) ||
			(this.systemCapabilityService.has(SystemCapabilityEnum.runReports) &&
				this.companyId === undefined);

		// Populate user to get canViewAuditLogs from backend
		await this.populateUser();

		// Backend determines if audit logs can be viewed based on:
		// 1. Requesting user has audit capability, AND
		// 2. Either requesting user is Sentrilock OR user belongs to requesting user's company
		this.canAccessAuditLogs = this.user?.canViewAuditLogs ?? false;

		this.updateBreadcrumbLabels();
	}

	async populateUser(): Promise<void> {
		this.user = await this.api.getUserDetails(this.userId);
	}
}
